import highEmphasis from '../../text/high-emphasis';

const secondary = ({ backgroundColor, whiteColor, blackColor }) =>
  highEmphasis({ backgroundColor, whiteColor, blackColor });

export default secondary;
